import React from 'react';
import {
  SettingOutlined,
} from '@ant-design/icons';

export const routeList = [

  {
    key: 'sub8-1',
    text: 'Модуль солих',
    tText: 'modulSolih',
    icon: <SettingOutlined className="fs-20" />,
    url: '/company',
    nodeId: '20',
  },
  {
    key: 'sub8-2',
    text: 'Эрхийн тохиргоо',
    tText: 'role',
    icon: <SettingOutlined className="fs-20" />,
    url: '/company/tohirgoo/roleAdd',
    nodeId: '25',
  },
  {
    key: 'sub8-3',
    text: 'Хэрэглэгчийн тохиргоо',
    tText: 'user',
    icon: <SettingOutlined className="fs-20" />,
    url: '/company/tohirgoo/userAdd',
    nodeId: '26',
  },
  {
    key: 'sub8-4',
    text: 'Татвар төлөгчийн мэдээлэл',
    tText: 'tulugchMedeelel',
    icon: <SettingOutlined className="fs-20" />,
    url: '/company/tatvarTulugch/medeelel',
    nodeId: '27',
  },
  // {
  //   key: 'sub8-5',
  //   text: 'Үйлдлийн түүх',
  //   tText: 'audit',
  //   icon: <SettingOutlined className="fs-20" />,
  //   url: '/main/tohirgoo/auditLog',
  //   nodeId: '28',
  // },
  // {
  //   key: 'sub8-6',
  //   text: 'Системийн лог',
  //   tText: 'syslog',
  //   icon: <SettingOutlined className="fs-20" />,
  //   url: '/main/tohirgoo/sysLog',
  //   nodeId: '29',
  // },
  // {
  //   key: 'sub8-7',
  //   text: 'ТМЗ мониторинг',
  //   tText: 'tmz',
  //   icon: <SettingOutlined className="fs-20" />,
  //   url: '/main/tohirgoo/tmzMonitoring',
  //   nodeId: '30',
  // },


];

export const _menu = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
  [10, 11, 12],
];

export const settings = {
  dots: false,
  infinite: true,
  arrows: false,
  swipe: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
};
